import { TBroadcastScheduleProgramBodySegmentToolkitRotuloForm } from '../types';

const ROTULO_FORM_DEFAULT_VALUES: TBroadcastScheduleProgramBodySegmentToolkitRotuloForm = {
  p1x: 0,
  p1y: 0,
  p2x: 0,
  p2y: 0,
  rotulo: '',
  start: new Date(),
  end: new Date(),
  fiable: '',
  review_state: 0,
};

export { ROTULO_FORM_DEFAULT_VALUES };
